// (function ($) {
//   if ($(".sticky-nav").length > 0) {
//     var flag = 0; // pause scroll updates during click animation
//     var ticking = false; // rAF guard

//     // Smooth scroll on nav click
//     $(".sticky-nav ul li").on("click", function (e) {
//       e.preventDefault();
//       if (!$(this).hasClass("active")) {
//         var $Id = $(this).find("a").attr("href");

//         $(".sticky-nav ul li").removeClass("active");
//         $(this).addClass("active");

//         var tabHeight = $(".sticky-nav .container").outerHeight();
//         var headerHeight = $("header").outerHeight();
//         $(".sticky-nav").css("height", tabHeight + "px");

//         if ($Id !== "#") {
//           flag = 1;
//           $("html, body").animate(
//             {
//               scrollTop: $($Id).offset().top - headerHeight - tabHeight + 2,
//             },
//             500,
//             function () {
//               flag = 0;
//               highlightSection(); // sync after animation
//             }
//           );
//         }
//       }
//     });

//     // Detect if header is hidden (via transform)
//     function isHeaderHidden() {
//       var headerTransform = $("header").css("transform");
//       if (headerTransform && headerTransform !== "none") {
//         var matrix = headerTransform.replace(/[^0-9,\-\.]/g, "").split(",");
//         var translateY = parseFloat(matrix[5]) || 0;
//         return translateY < 0;
//       }
//       return false;
//     }

//     // Highlight active section
//     function highlightSection() {
//       if (flag) return;
//       if (!$(".sticky-nav").length) return;

//       var scrolled = $(document).scrollTop();
//       var tabHeight = $(".sticky-nav .container").outerHeight();
//       var headerHeight = $("header").outerHeight();
//       var hidden = isHeaderHidden();

//       // Sticky positioning
//       if (scrolled >= $(".sticky-nav").offset().top - headerHeight) {
//         $(".sticky-nav").addClass("fixed");
//         $(".sticky-nav").css("height", tabHeight + "px");
//         $(".sticky-nav .container").css({
//           position: "fixed",
//           top: hidden ? 0 : headerHeight + "px",
//           left: 0,
//           right: 0,
//           zIndex: 13,
//         });
//       } else {
//         $(".sticky-nav").removeAttr("style");
//         $(".sticky-nav .container").removeAttr("style");
//         $(".sticky-nav").removeClass("fixed");
//       }

//       // Active section highlight
//       var anyActive = false;

//       $(".sticky-nav ul li").each(function () {
//         var $Id = $(this).find("a").attr("href");
//         if ($Id && $Id !== "#" && $($Id).length > 0) {
//           var sectionTop = $($Id).offset().top - (hidden ? tabHeight : headerHeight + tabHeight);
//           var sectionBottom = sectionTop + $($Id).outerHeight();

//           if (scrolled >= sectionTop && scrolled < sectionBottom) {
//             $(".sticky-nav ul li").removeClass("active");
//             $(this).addClass("active");
//             anyActive = true;
//           }
//         }
//       });

//       // Special case: first li if its section is adjacent
//       if (!anyActive) checkFirstLiAdjacent();
//     }

//     // Check if first li should be active (section adjacent to sticky)
//     function checkFirstLiAdjacent() {
//       var firstLi = $(".sticky-nav ul li:first-child");
//       var firstId = firstLi.find("a").attr("href");

//       if (firstId && $(firstId).length > 0) {
//         var headerHeight = $("header").outerHeight() || 0;
//         var tabHeight = $(".sticky-nav .container").outerHeight() || 0;
//         var stickyBottom = $(".sticky-nav").offset().top + $(".sticky-nav").outerHeight();

//         var sectionTop = $(firstId).offset().top;
//         var sectionBottom = sectionTop + $(firstId).outerHeight();
//         var scrollPos = $(document).scrollTop();

//         if (
//           scrollPos <= sectionTop &&           // page is at or above section
//           sectionTop <= stickyBottom &&        // section touches sticky bottom
//           sectionBottom > stickyBottom         // section extends into viewport
//         ) {
//           $(".sticky-nav ul li").removeClass("active");
//           firstLi.addClass("active");
//         }
//       }
//     }

//     // rAF-powered scroll handler
//     function onScroll() {
//       if (!ticking) {
//         window.requestAnimationFrame(function () {
//           highlightSection();
//           ticking = false;
//         });
//         ticking = true;
//       }
//     }

//     // Bind scroll
//     $(window).on("scroll", onScroll);

//     // Run on load
//     $(window).on("load", function () {
//       highlightSection();
//     });

//     // Throttled resize
//     var resizeTimeout;
//     $(window).on("resize", function () {
//       clearTimeout(resizeTimeout);
//       resizeTimeout = setTimeout(function () {
//         highlightSection();
//       }, 150);
//     });
//   }
// })(jQuery);

document.addEventListener('DOMContentLoaded', function() {
  const stickyNav = document.querySelector('.sticky-nav');
  
  // Exit early if sticky nav is not available on this page
  if (!stickyNav) {
      return;
  }
  
  const header = document.querySelector('.header');
  const navLinks = document.querySelectorAll('.sticky-nav-link');
  const sections = document.querySelectorAll('section[id]');
  // Record the original top offset of the sticky nav to know when to fix/unfix
  const stickyOriginalOffsetTop = stickyNav.offsetTop;
  
  // Additional check to ensure we have the required elements
  if (!navLinks.length || !sections.length) {
      return;
  }
  
  let prevScrollPos = window.pageYOffset;
  let ticking = false;

  // Default: set first nav link's parent active
  if (navLinks[0] && navLinks[0].parentElement) {
      navLinks[0].parentElement.classList.add('active');
  }
  
  // Smooth scroll to section
  function smoothScrollToSection(targetId) {
      if (!stickyNav) return;
      
      const targetSection = document.querySelector(targetId);
      if (targetSection) {
          const headerHeight = header ? header.offsetHeight : 0;
          const stickyNavHeight = stickyNav ? stickyNav.offsetHeight : 0;
          const currentScrollTop = window.pageYOffset;
          const targetSectionTop = targetSection.offsetTop;
          
          let targetOffset;
          
          // Above 1280px width keep existing behavior; below 1280px always subtract header
          const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
          if (viewportWidth >= 1280) {
              // Check if target section is below current scroll position
              if (targetSectionTop > currentScrollTop) {
                  // Section is below - position at sticky nav height
                  targetOffset = targetSectionTop - stickyNavHeight;
              } else {
                  // Section is above - position at sticky nav height + header height
                  targetOffset = targetSectionTop - stickyNavHeight - headerHeight;
              }
          } else {
              // Below 1280px: always account for header height
              targetOffset = targetSectionTop - stickyNavHeight - headerHeight;
          }
          
          window.scrollTo({
              top: targetOffset,
              behavior: 'smooth'
          });
      }
  }
  
  // Update active nav link
  function updateActiveNavLink() {
      if (!stickyNav || !navLinks.length || !sections.length) return;
      
      const headerHeight = header ? header.offsetHeight : 0;
      const scrollPosition = window.scrollY + headerHeight + 106; // 110px offset for better detection
      
      sections.forEach(section => {
          const sectionTop = section.offsetTop;
          const sectionHeight = section.offsetHeight;
          const sectionId = section.getAttribute('id');
          
          if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
              // Remove active class from all links and underlines
              navLinks.forEach(link => {

                  link.classList.remove('active');
                  // Also remove active from the link's parent element (e.g., li)
                  if (link.parentElement) {
                      link.parentElement.classList.remove('active');
                  }
              });
              
              // Add active class to current section link
              const activeLink = document.querySelector(`[href="#${sectionId}"]`);
              if (activeLink) {

                  activeLink.classList.add('active');
                  // Also add active to the link's parent element (e.g., li)
                  if (activeLink.parentElement) {
                      activeLink.parentElement.classList.add('active');
                  }
              }
            }
        });
    }
  
  // Handle sticky nav hide/show based on scroll direction
  function handleStickyNavScroll() {
      if (!stickyNav) return;
      
      if (window.innerWidth > 1023) {
          if (window.scrollY > 100) {
              const currentScrollPos = window.pageYOffset;
              const headerHeight = header ? header.offsetHeight : 0;
              
              if (prevScrollPos > currentScrollPos) {
                  // Scrolling up: show sticky nav
                  stickyNav.style.top = `${headerHeight}px`;
              } else {
                  // Scrolling down: hide sticky nav
                  stickyNav.style.top = "0";
              }
              
              prevScrollPos = currentScrollPos;
          } else {
              // At top: show sticky nav
              stickyNav.style.top = "0";
          }
      }
      
      // Toggle 'fixed' class based on original position
      const scrolledY = window.pageYOffset || window.scrollY || 0;
      if (scrolledY >= stickyOriginalOffsetTop) {
          stickyNav.classList.add('fixed');
      } else {
          stickyNav.classList.remove('fixed');
          if (navLinks[0] && navLinks[0].parentElement) {
              const firstParent = navLinks[0].parentElement;
              if (!firstParent.classList.contains('active')) {
                  firstParent.classList.add('active');
              }
          }
      }
      
      updateActiveNavLink();
  }
  
  // Throttled scroll handler
  function throttledScrollHandler() {
      if (!ticking) {
          requestAnimationFrame(() => {
              handleStickyNavScroll();
              ticking = false;
          });
          ticking = true;
      }
  }
  
  // Event listeners
  window.addEventListener('scroll', throttledScrollHandler);
  
  // Click handlers for nav links
  navLinks.forEach(link => {
      link.addEventListener('click', function(e) {
          e.preventDefault();
          const targetId = this.getAttribute('href');
          smoothScrollToSection(targetId);
      });
  });
  
  // Initialize
  updateActiveNavLink();
}); 